import { Church, BookOpen, Fish, Trophy, Ambulance } from "lucide-react";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();

  const icons = [
    <Church />,
    <BookOpen />,
    <BookOpen />,
    <Fish />,
    <Trophy />,
    <Ambulance />,
  ];

  const services = t("services", { returnObjects: true });

  return (
    <div className="relative mt-7 border-2 border-solid border-neutral-800 min-h-[500px] dark:bg-gray-900 bg-[#85c4de]">
      <div className="text-center">
        <h2 className="text-3xl sm:text-5xl lg:text-6xl mt-10 lg:mt-10 tracking-wide dark:text-white text-black">
          {t("servicesTitle")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-orange-800 text-transparent bg-clip-text">
            {t("servicesSubTitle")}
          </span>
        </h2>
      </div>
      <div className="flex flex-wrap mt-4 lg:mt-4">
        {services.map((service, index) => (
          <div key={index} className="w-full sm:w-1/2 lg:w-1/3">
            <div className="flex">
              <div className="flex mx-6 h-10 w-10 p-2 bg-neutral-900 text-orange-700 justify-center items-center rounded-full">
                {icons[index]}
              </div>
              <div>
                <h5 className="mt-1 mb-2 text-xl dark:text-white text-black">
                  {service.text}
                </h5>
                <p className="text-md p-2 mb-5 dark:text-neutral-300 text-neutral-500">
                  {service.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
